module.exports = __webpack_public_path__ + "static/img/8areaB_12.f949799.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/8areaB_12.png
// module id = 1241
// module chunks = 1